import { useState } from 'react';
import { CashTypeEnum } from '../../../enums/cashType';
import { DriverFinancialModel } from '../../../models/driverFinancial';
import { OrderDriverFinancial } from '../../../models/orderDriverFinancial';
import { DEFAULT_ROWS_PER_PAGE } from '../../../config-global';

interface Props {
  selectedData: DriverFinancialModel;
}

const useOrderDetailRiderFinancialController = ({ selectedData }: Props) => {
  const [tabOrderMoney, setTabOrderMoney] = useState<CashTypeEnum>(CashTypeEnum.CASH);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const getOrderDataByCashType = (cashType: CashTypeEnum) => {
    if (cashType === CashTypeEnum.CASH) {
      return selectedData?.ordersCash?.orders || [];
    } else if (cashType === CashTypeEnum.ONE_PAY) {
      return selectedData?.ordersOnePay?.orders || [];
    } else if (cashType === CashTypeEnum?.RETURN) {
      return selectedData?.ordersReturn?.orders || [];
    } else {
      return [];
    }
  };

  const getOrder = getOrderDataByCashType(tabOrderMoney);
  const filterData = getOrder;

  const rows = filterData?.slice(
    (currentPage - 1) * DEFAULT_ROWS_PER_PAGE,
    currentPage * DEFAULT_ROWS_PER_PAGE + DEFAULT_ROWS_PER_PAGE
  );

  const countPagination = Math.ceil(filterData?.length / DEFAULT_ROWS_PER_PAGE);

  const handleTabOrderMoneyType = (newValue: CashTypeEnum) => {
    setTabOrderMoney(newValue);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setCurrentPage(newPage);
  };

  return {
    handleTabOrderMoneyType,
    tabOrderMoney,
    handleChangePage,
    currentPage,
    countPagination,
    rows,
  };
};
export default useOrderDetailRiderFinancialController;
